import httpAuth from '@/services/httpAuth'

export async function uploadImagem (file, campanhaId) {
  await httpAuth.post(`/crm/campanhas/uploadimagem/${campanhaId}`, file)
}

export async function programarEnvio (campanhaId) {
  return httpAuth.get(`/crm/campanhaprogramarenvio/${campanhaId}`)
}

export async function enviarEmailExemplo (obj) {
  return httpAuth.post('/crm/campanhas/enviaremailexemplo', obj)
}

export async function atualizarClientes (obj) {
  return httpAuth.put('/crm/atualizarclientes', obj)
}

export async function excelCampanhaClientes (filtros) {
  return httpAuth.post(`/crm/campanhaclientes/exportarexcel?${filtros}`)
}

export async function excelCampanhaLogs (filtros) {
  return httpAuth.post(`/crm/campanhalogs/exportarexcel?${filtros}`)
}

export async function enviarCampanhaExemplo (campanhaId) {
  return httpAuth.get(`/crm/campanhas/enviarcampanha/${campanhaId}`)
}
